import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFreightTermsAccepted } from "../redux/deliveryFeeRedux";

const VEHICLE_LABEL = { CAR: "a car", VAN: "a van", TRUCK: "a truck" };

export default function FreightCheckoutNotice() {
  const dispatch = useDispatch();
  const { fulfillment, freightTermsAccepted } = useSelector((state) => state.deliveryFee);
  const vehicle = VEHICLE_LABEL[fulfillment?.loadClass];
  // A basket that needs more than a motorbike is priced for that vehicle at
  // checkout. Say so, or the fee looks wrong next to a smaller basket's.
  if (fulfillment?.required !== true && vehicle) {
    return (
      <div role="note" style={{ background: "#eef6f5", border: "1px solid #bfe0da", borderRadius: 10, padding: "12px 16px", margin: "12px 0", color: "#0f4c45", fontSize: 14, lineHeight: 1.5 }}>
        <strong>Delivered by {vehicle}.</strong> This order is larger than a motorbike can carry
        {fulfillment?.totals?.weightKg > 0 ? ` (about ${Math.round(fulfillment.totals.weightKg)} kg)` : ""}, so the delivery fee covers {vehicle}.
      </div>
    );
  }
  if (fulfillment?.required !== true) return null;

  return (
    <div role="alert" style={{ background: "#fff8e1", border: "1px solid #f2c94c", borderRadius: 10, padding: 16, margin: "16px 0", color: "#5d4300" }}>
      <div style={{ fontWeight: 800, marginBottom: 6 }}>Large or bulk delivery — freight is quoted separately</div>
      <div style={{ fontSize: 14, lineHeight: 1.5 }}>
        {fulfillment.checkoutNotice || "Delivery is not included in this checkout. Lusuku will send a separate freight quote for your approval and contact you to arrange a delivery appointment."}
      </div>
      {fulfillment.requiredCarrierType && fulfillment.requiredCarrierType !== "ANY" && (
        <div style={{ fontSize: 14, marginTop: 6 }}>
          Minimum transport class: <strong>{fulfillment.requiredCarrierType.toLowerCase()}</strong>.
        </div>
      )}
      <label style={{ display: "flex", gap: 10, alignItems: "flex-start", marginTop: 12, cursor: "pointer", fontWeight: 600 }}>
        <input
          type="checkbox"
          checked={freightTermsAccepted === true}
          onChange={(event) => dispatch(setFreightTermsAccepted(event.target.checked))}
          style={{ marginTop: 3 }}
        />
        I understand that the merchandise total below excludes freight and that no freight charge will be added without my approval.
      </label>
    </div>
  );
}
